import classes from './ReportResult.module.css';
import { withoutScenarios } from 'features/roleplay/RoleplayConstants';

const ScenarioContext = ({
  prospectName = '',
  customer_role = '',
  customer_industry = '',
  customer_situation = '',
  selectedScenario = {},
  scenarios,
  title = '',
}) => {
  return (
    <div>
      <h4>🔰 Scenario Context</h4>
      <div
        className={`${classes.content} ${
          !withoutScenarios.includes(selectedScenario?.name) &&
          scenarios?.length >= 1 &&
          selectedScenario?.name !== title
            ? ''
            : classes.threeItems
        }`}
      >
        <div className={classes.itemContext}>
          <p>
            Prospect:
            <span className={classes.subtitle}>{` ${prospectName}, ${customer_role}`}</span>
          </p>
        </div>
        <div className={classes.itemContext}>
          <p>
            Industry:
            <span className={classes.subtitle}>{` ${customer_industry}`}</span>
          </p>
        </div>

        {!withoutScenarios.includes(selectedScenario?.name) &&
          scenarios?.length >= 1 &&
          selectedScenario?.name !== title && (
            <div className={classes.itemContext}>
              <p>
                Scenario:
                <span className={classes.subtitle}>{` ${selectedScenario?.name}`}</span>
              </p>
            </div>
          )}
        <div className={classes.itemContext}>
          <p>
            Customer Situation:
            <span className={classes.subtitle}>{` ${customer_situation}`}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScenarioContext;
